import React, { Component } from "react";

class SimpeDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            fileName: null,
        }
        this.fileInputRef = React.createRef();
    }

    handleButtonClick = () => {
        this.fileInputRef.current.click();
    };

    handleFileChange = (event) => {
        const file = event.target.files[0]; // Get the uploaded file
        if (file) {
            this.setState({ fileName: file.name });
            this.props.onChange("file", file);
        }
    };

    render() {
        const { label, mandatory, readOnly, disabled, loading } = this.props
        return (
            <div className="margin-bottom-20px card-date-picker">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                </div>
                <div className="double">
                    <input
                        {...this.props}
                        style={{backgroundColor: readOnly && "#E6E6E6"}}
                        type="text"
                        className="txt txt-sekunder-color"
                        placeholder=""
                        value={this.state.fileName}
                    />
                    <input
                        {...this.props}
                        type="file"
                        id={this.props.idInputFile || null}
                        ref={this.fileInputRef}
                        onChange={this.handleFileChange}
                        hidden
                    />
                    {!disabled &&
                        <button
                            disabled={loading}
                            className="btn btn-grey border-left btn-no-radius"
                            type="button"
                            onClick={() => this.handleButtonClick()}>
                            <i className={loading ? "fa fa-lg fa-spinner" : "fa fa-lg fa-file"}></i>
                        </button>
                    }
                </div>
            </div>
        )
    }
}

export default SimpeDoc